<div class="dialog-content">
  <div class="dialog-header">
    <span class="dialog-heading">
      <span *ngIf="importingData.action === 'Add'">Add a new account</span>
      <span *ngIf="importingData.action !== 'Add'">Edit account</span>
    </span>
    <mat-icon class="h-24-w-24 cursor-pointer" mat-dialog-close>close</mat-icon>
  </div>

  <ng-container *ngIf="importingData.action === 'Add'; else editBlock">
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Konto</mat-label>
          <input name="konto" matInput [(ngModel)]="accountData.konto" required />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Naziv konta</mat-label>
          <input name="nazivKonta" matInput [(ngModel)]="accountData.nazivKonta" required />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormValid()"
          [promiseBtn]="adding"
          (click)="addNewAccountFromDialog()"
        >
          <mat-icon>add</mat-icon>
          <span class="ml-8">Add account</span>
        </button>
      </div>
    </form>
  </ng-container>

  <ng-template #editBlock>
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Konto</mat-label>
          <input name="konto" matInput [(ngModel)]="accountDataEdit.konto" required />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Naziv konta</mat-label>
          <input name="nazivKonta" matInput [(ngModel)]="accountDataEdit.nazivKonta" required />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormDirty() || !isFormValid()"
          [promiseBtn]="adding"
          (click)="editAccountFromDialog()"
        >
          <mat-icon>save</mat-icon>
          <span class="ml-8">Update account</span>
        </button>
      </div>
    </form>
  </ng-template>
</div>
